import data from '../../data/basic.json';

export const GAME_STATUSES = {
    BEFORE_PLAY: 'beforePlay',
    PLAY: 'play',
    PAUSE: 'pause',
    END: 'end'
};

export const EGGS_TYPES = {
    UNSET: 'unset',

    BALL: 'ball',
    BALL_JUMP: 'ball-jump'
};

export const EGGS_SET = [
    /* EGGS_TYPES.BALL,
    EGGS_TYPES.BALL,
    EGGS_TYPES.BALL,
    EGGS_TYPES.BALL,
    EGGS_TYPES.BALL, */
    EGGS_TYPES.BALL,
    EGGS_TYPES.BALL_JUMP
];

export const ORIENTATIONS = {
    LANDSCAPE: 'landscape-primary',
    PORTRAIT: 'portrait-primary'
};

export const ANALYTICS = [
    {
        count: data.gameSettings.maxScore - 1,
        label: `> ${data.gameSettings.maxScore - 1}`
    },
    {
        count: 1500,
        label: '> 1500'
    },
    {
        count: 1000,
        label: '> 1000'
    },
    {
        count: 500,
        label: '> 500'
    },
    {
        count: 300,
        label: '> 300'
    },
    {
        count: 200,
        label: '> 200'
    },
    {
        count: 100,
        label: '> 100'
    },
    {
        count: 50,
        label: '> 50'
    },
    {
        count: 10,
        label: '> 10'
    },
    {
        count: 0,
        label: '> 0'
    }
];
